import React from "react";
import { motion } from "framer-motion";
import { Outlet, Link } from "react-router-dom";
import {
  Calendar,
  Phone,
  LogOut,
} from "lucide-react";

const SidebarItem = ({ icon: Icon, label, badge, isNew, to, onClick }) => (
  <Link
    to={to}
    onClick={onClick}
    className="flex items-center justify-between px-4 py-2 hover:bg-slate-700 cursor-pointer rounded-md transition"
  >
    <div className="flex items-center gap-3">
      <Icon className="w-5 h-5 text-slate-300" />
      <span className="text-slate-200 text-sm">{label}</span>
    </div>
    {badge && <span className="text-xs bg-red-600 text-white px-1.5 py-0.5 rounded-full">{badge}</span>}
    {isNew && <span className="text-xs bg-blue-600 text-white px-1.5 py-0.5 rounded-full">New</span>}
  </Link>
);


const Dashboard = () => {
  return (
    <div className="flex h-screen bg-slate-100">
      {/* Sidebar */}
      <motion.div
        initial={{ x: -200 }}
        animate={{ x: 0 }}
        transition={{ duration: 0.4 }}
        className="w-64 bg-slate-900 text-white flex flex-col justify-between"
      >
        <div>
          <div className="flex items-center justify-center h-16 text-xl font-bold tracking-widest bg-slate-800">
            <span className="text-blue-500">🟦</span> ADMIN
          </div>

          <div className="p-4 space-y-6 overflow-y-auto">
            <div>
              <h3 className="text-slate-400 text-xs mb-2">CUSTOM</h3>
              <SidebarItem icon={Calendar} label="Quote data" to="/dashboard/packageenquiry" />
              {/* <SidebarItem icon={Calendar} label="Add Package" to="/dashboard/addpackage" />
              <SidebarItem icon={FileText} label="Edit Package" to="/dashboard/editpackage" /> */}
              <SidebarItem icon={Phone} label="Callback Requests" to="/dashboard/callbackrequests" />

            </div>
          </div>
        </div>

        {/* Logout + Footer */}
        <div className="space-y-3 p-4 border-t border-slate-700">
          <SidebarItem icon={LogOut} label="Logout" to="/login" />
          <div className="text-center text-slate-500 text-xs">2025 © Tripocation Holiday</div>
        </div>
      </motion.div>

      {/* Right side content for nested routes */}
      <div className="flex-1 p-6 overflow-y-auto bg-slate-800">
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
